@let person = loadedPerson();
<div class="dialogContainer">
  <div class="header">
    <h2>Skyport Contact</h2>
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  <div class="content skyportPage">
    <div class="inputLayout">
      <tr>
        <td class="columnLabel"><label for="firstNameInput">Contact First Name</label></td>
        <td class="columnInput"><input name="firstNameInput" class="inputField standardTextBox" maxlength="30"
        id="firstNameInput" [(ngModel)]="person.firstName" #firstName="ngModel"/></td>
      </tr>
      <tr>
        <td class="columnLabel"><label for="lastNameInput">Contact Last Name</label></td>
        <td class="columnInput"><input name="lastNameInput" class="inputField standardTextBox" maxlength="30"
        id="lastNameInput" [(ngModel)]="person.lastName" #lastName="ngModel"/></td>
      </tr>
    <tr>
      <td class="columnLabel"><label for="phoneNumberInput">Contact Phone Number</label></td>
      <td class="columnInput"><input name="phoneNumberInput" class="inputField standardTextBox" maxlength="20"
        id="phoneNumberInput" [(ngModel)]="person.defaultPhoneNumber"
      #phoneNumber="ngModel"/></td>
    </tr>
    <tr>
      <td class="columnLabel"><label for="emailInput">Contact E-Mail</label></td>
      <td class="columnInput"><input name="emailInput" class="inputField standardTextBox" maxlength="250"
        id="emailInput" [(ngModel)]="person.emailAddress.emailAddress" #email="ngModel"/>
    </td>
  </tr>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
</div>
<div mat-dialog-actions>
  <span class="spacer"></span>
  <span>
    <button matButton="elevated" [disabled]="isBusy()" (click)="saveAndClose()">Save</button>
    <button matButton="elevated" (click)="cancel()">Cancel</button>
  </span>
</div>
</div>
